module.exports = __webpack_public_path__ + "static/img/close-icon.894e99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/close-icon.png
// module id = TP+x
// module chunks = 1